<nice-layout>
    <div class="page relative flex flex-col flex-auto justify-center items-center gap-24 w-full h-full min-w-0">
        <div class="flex items-center gap-24">
            <div class="w-100">
                <img ngSrc="assets/images/logo-municipal.svg" height="150" width="400">
            </div>

            <mat-icon class="icon-size-12 text-accent" svgIcon="streamline-regular:remove"></mat-icon>

            <div class="w-100" *ngIf="organisation$ | async as organisation">
                <img [ngSrc]="organisation.logo" height="150" width="400" />
            </div>
        </div>

        <div class="flex flex-col justify-center items-center">
            <div class="flex flex-col justify-center items-center gap-1">
                <div class="title">{{ "features.unauthorized.title" | translate }}</div>
                <div class="description">{{ "features.unauthorized.description" | translate }}</div>
            </div>
        </div>

        <div class="flex flex-col items-center gap-8">
            <div class="text-lg">
                {{ "features.unauthorized.available_sites" | translate }}
            </div>

            <div class="flex flex-row flex-wrap justify-center gap-12 w-full" *ngIf="session$ | async as session">
                <div
                    *ngFor="let access of session.metadata.accesses"
                    class="flex flex-col justify-between basis-125 gap-4 h-64 rounded bg-white border border-accent/25 active:border-accent p-5 cursor-pointer"
                    (click)="redirect(access)"
                >
                    <div class="px-8 py-4 flex justify-center max-h-44">
                        <img [src]="access.organisation?.imageUrl" />
                    </div>

                    <div class="text-xl text-primary font-bold">
                        {{ access.organisation?.name }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</nice-layout>
